import { Fonts } from '@/constants/font';
import { Keys } from '@/constants/key';
import { Tr } from '@/i18n/i18n';
import { Profile } from '@/store/profile/types';
import CU from '@/utils/c-u';
import TextUtils from '@/utils/text-utils';
import BBCodeText from 'phaser3-rex-plugins/plugins/bbcodetext';
import { ListManualLink } from './list-manual-link';
import { VerticalLongPanel } from './vertical-long-panel';

const BUY_GEMS_DESCRIPTION = "buyGemsDesc";

export class GiftGemsPanel extends VerticalLongPanel {

    constructor(scene: Phaser.Scene, canvas: HTMLCanvasElement, giftText: string, receiver: Profile, buyButtonClickCallback: CallableFunction) {
        super(scene, canvas, Tr('gift.gems'));

        const textWithPlayerName = TextUtils.replacePlayerName(giftText, receiver.displayingName);
        const textWithPronouns = TextUtils.replacePronounsByPlayerGender(textWithPlayerName, receiver.gender);

        const giftGemsText = new BBCodeText(scene, - this.getContentWidth() * CU.S / 2, this.getXButtonY() * CU.S + 90 * CU.S, textWithPronouns, {
            fontFamily: Fonts.MYRIADPRO_REGULAR,
            fontSize: '14pt',
            align: 'center',
            wrap: {
                mode: 1,
                width: this.getContentWidth()
            }
        }).setScale(CU.S, CU.S);

        const detailsLink = new ListManualLink(this.scene, this.canvas!, BUY_GEMS_DESCRIPTION, Tr('det'), this.getDetailsLinkHeight()).setPosition(0, giftGemsText.getBottomCenter().y + 30);

        this.addCustomButton(-this.getActionButtonsOffsetX(), this.getCloseButtonY(), Tr('close').toUpperCase(), Keys.UI_ART_RED_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_DECLINE_CROSS, () => this.close(), false);
        this.addCustomButton(this.getActionButtonsOffsetX(), this.getCloseButtonY(), Tr('to.purchase').toUpperCase(), Keys.UI_ART_GREEN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, () => buyButtonClickCallback(receiver), false);
        this.add([giftGemsText, detailsLink]);
    }

    private getContentWidth(): number {
        return 420;
    }

    private getDetailsLinkHeight(): number {
        return 60;
    }

    private getActionButtonsOffsetX(): number {
        return 100;
    }

}